import { PropsWithChildren } from 'react';
import { AppShell } from './AppShell';
import { MAIN_CONTENT_ID } from '@repo/atomic-components';

export const LoginTemplate = ({ children }: PropsWithChildren) => {
  return (
    <AppShell>
      <div className="grid h-full w-full grid-cols-[1fr] grid-rows-[1fr] gap-0">
        <main
          id={MAIN_CONTENT_ID}
          tabIndex={-1}
          className="order-0 col-span-full flex flex-col items-center justify-center focus:outline-none"
        >
          {children}
        </main>
      </div>
    </AppShell>
  );
};
